const MEDIA_ITEMS = [
  {
    title: '《流浪地球3》先导预告',
    category: '科幻',
    duration: '02:18',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20futuristic%20space%20station%20with%20Earth%20in%20background%2C%20dramatic%20orange%20and%20gold%20sunlight%2C%20sci-fi%20cinematic%20lighting%2C%20massive%20engines%20glowing%2C%20film%20trailer%20aesthetic%2C%20widescreen&width=640&height=360&seq=media-wandering-3&orientation=landscape',
    views: '128万',
  },
  {
    title: '《封神第二部》幕后特辑',
    category: '奇幻',
    duration: '05:32',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20battlefield%20with%20warriors%20in%20elaborate%20armor%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20epic%20fantasy%20cinematography%2C%20warm%20cinematic%20color%20grading&width=640&height=360&seq=media-fengshen&orientation=landscape',
    views: '96万',
  },
  {
    title: '《海贼王》特别篇预告',
    category: '动漫',
    duration: '01:45',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20pirate%20ship%20sailing%20on%20golden%20ocean%20at%20sunset%2C%20anime%20style%20illustration%20with%20vibrant%20warm%20colors%2C%20dramatic%20clouds%2C%20adventure%20atmosphere%2C%20cinematic%20composition&width=640&height=360&seq=media-onepiece-sp&orientation=landscape',
    views: '203万',
  },
  {
    title: 'BBC《地球脉动III》精选片段',
    category: '纪录',
    duration: '08:15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20mountain%20range%20with%20golden%20sunrise%20light%2C%20diverse%20ecosystem%2C%20documentary%20cinematography%2C%20rich%20natural%20color%20palette%2C%20warm%20atmospheric%20haze&width=640&height=360&seq=media-planet-3&orientation=landscape',
    views: '67万',
  },
  {
    title: '《狂飙》名场面混剪',
    category: '剧情',
    duration: '03:50',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20scene%20with%20dramatic%20interrogation%20room%20lighting%2C%20strong%20contrast%20shadows%2C%20noir%20cinematography%2C%20warm%20single%20overhead%20lamp%2C%20tense%20atmosphere&width=640&height=360&seq=media-kuangbiao&orientation=landscape',
    views: '156万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">精彩预告</h2>
            <p className="mt-2 text-sm text-foreground-500">热门影片预告与精选片段，抢先一睹为快</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
            {MEDIA_ITEMS.map((item, i) => (
              <div
                key={i}
                className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500/80 transition-colors">
                      <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-xs font-medium">
                    {item.duration}
                  </div>
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-500/90 text-white">
                      {item.category}
                    </span>
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">{item.title}</h3>
                  <div className="mt-1.5 flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-eye-line"></i>
                    <span>{item.views} 次观看</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}